import React, { FC } from 'react';

import { useCheck } from 'Src/feature/check/useCheck';
import { Modal } from 'Src/feature/modal/Modal';
import { PaymentCompleteModalContent } from 'Src/feature/payment/PaymentCompleteModal';
import { useCheckPagePayment } from 'Src/feature/payment/useCheckPagePayment';
import { useCurrentPayment } from 'Src/feature/payment/useCurrentPayment';
import { usePaymentFlow } from 'Src/feature/payment/usePaymentFlow';
import useRoute from 'Src/routes/useRoute';

type CheckPaymentCompleteModalControl = ReturnType<typeof useCheckPagePayment>['modal']['payComplete'];

interface CheckPaymentCompleteModalProps {
  ['data-testid']: string;
  control: CheckPaymentCompleteModalControl;
}

const CheckPaymentCompleteModalContent: FC<CheckPaymentCompleteModalProps> = ({ control }) => {
  const paymentFlow = usePaymentFlow();
  const { route } = useRoute();

  const currentPayment = useCurrentPayment();
  const checkId = route.params.active.checkId ? parseInt(route.params.active.checkId, 10) : undefined;
  const checkGetOne = useCheck.query.getOne(checkId);
  const check = checkGetOne.data;
  // manual cc payment might not be persistent
  // - unsure if this is still needed but might be a previously persisting state issue
  const paymentId = paymentFlow.pay.id || currentPayment.epx?.response?.paymentId;
  const payment =
    typeof paymentId === 'string'
      ? check?.payments.find(({ id }) => id === paymentId)
      : undefined;

  const showGitCardBalance = paymentFlow.is.gc || payment?.paymentType === 'GiftCard';

  return (
    <PaymentCompleteModalContent
      open={control.isOpen}
      payment={payment}
      showGitCardBalance={showGitCardBalance}
      onClose={() => control.close('on-user-cancel')}
      onReceipt={() => control.onReceiptClick(payment?.id as string)}
      onVoid={control.onVoidClick}
      isProcessing={checkGetOne.isPending}
    />
  );
};

// eslint-disable-next-line react/no-multi-comp
const CheckPaymentCompleteModal: FC<CheckPaymentCompleteModalProps> = (props) => (
  <Modal
    data-testid={props['data-testid']}
    open={props.control.isOpen}
    onBackDropClick={() => props.control.close('on-user-cancel')}
  >
    <CheckPaymentCompleteModalContent {...props} />
  </Modal>
);

export { CheckPaymentCompleteModal };
export type { CheckPaymentCompleteModalProps };
